// extracted by mini-css-extract-plugin
export default {"drawer":"a7xhi","drawerContent":"cy2T1","agreement":"f61dc","drawerFooter":"IIN68","drawerClose":"lES6k"};